<template>
  <mdb-modal :show="modal" @close="close" :size="size" :scrollable="scrollable">
    <mdb-modal-header v-if="!disableHeader">
      <mdb-modal-title>{{ title }}</mdb-modal-title>
    </mdb-modal-header>
    <mdb-modal-body>
      <p v-if="body">{{ body }}</p>
      <slot></slot>
    </mdb-modal-body>
    <mdb-modal-footer v-if="!disableCancelButton || !disableOkButton">
      <mdb-btn color="danger" @click.native="close" :class="{ 'd-none': disableCancelButton }">キャンセル</mdb-btn>
      <mdb-btn color="primary" @click.native="accept" :class="{ 'd-none': disableOkButton }">OK</mdb-btn>
    </mdb-modal-footer>
  </mdb-modal>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    modal: Boolean,
    size: String,
    scrollable: Boolean,
    title: String,
    body: String,
    disableHeader: Boolean,
    disableCancelButton: Boolean,
    disableOkButton: Boolean
  },
  methods: {
    close: function() {
      this.$emit('close')
    },
    accept: function() {
      this.$emit('accept')
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/_variables.scss";

.modal {
  color: $secondary-color !important;
}
</style>
